module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/customers/customers.component.scss
// module id = ./src/app/customers/customers.component.scss
// module chunks = main